module.exports = __webpack_public_path__ + "img/yidong.24b1a426.png";